import { createFileRoute } from '@tanstack/react-router';
import { UserManagementPage } from '@/pages/UserManagement';
import { z } from 'zod';

const searchSchema = z.object({
  page: z.number().catch(1).optional(),
});

export const Route = createFileRoute('/_admin/user-management')({
  validateSearch: searchSchema,
  component: UserManagementPage,
});
